import * as React from 'react'
import { isTreatment, safeBoolean } from '../../utils/utils'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { AtfTreatmentProps } from '../../reducers/features'
import * as badgeSt from './badge.module.scss'

export interface HdrBadgeProps extends AtfTreatmentProps {
  isHdr?: boolean
}

export const Hdr = ({ isHdr, atfTreatment }: HdrBadgeProps) => (
  safeBoolean(isHdr) &&
  (<Badge use={badges.BORDERED_TEXT}>
    <span {...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { className: badgeSt.lightBadge})} data-automation-id="hdr-badge">HDR</span>
  </Badge>) || null
)
